import { createVNode as l, mergeProps as m } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ZoomFilled.js";
import s from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return l(s, m(t, {
    icon: i
  }), null);
};
o.displayName = "ZoomFilled";
o.inheritAttrs = !1;
export {
  o as default
};
